<template lang="html">
  <footer class="menu">
    <router-link :to="{ name: 'home' }" v-html="site.description"></router-link>
    <nav>
      <router-link :to="{ name: 'articles' }">Articles (文章)</router-link> —
      <router-link :to="{ name: 'database' }">Database (数据库)</router-link> —
      <router-link :to="{ name: 'about' }">About (关于)</router-link>
    </nav>
  </footer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "aizi-menu",
  computed: mapState(["site"]),
};
</script>

<style lang="scss">
.menu {
  width: 100%;
  background: var(--color);
  color: var(--hover);
  padding: var(--lh);
  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr 1fr;
  // height: calc(5 * var(--lh));
  p {
    margin-bottom: 0 !important;
  }
  a {
    color: var(--hover);
  }
  a:hover {
    color: var(--bg);
  }
  a.router-link-active {
    color: var(--bg);
  }
  .col {
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    border-right: 1px solid white;

    &:last-of-type {
      border-right: 0px;
    }
  }
  @media only screen and (max-width: 768px) {
    // height: calc(8.5 * var(--lh));
    // grid-template-columns: 1fr 1fr;
    // .col:nth-of-type(2n) {
    // border-right: 0;
    // }
    // .col:nth-of-type(1) {
    // border-bottom: 0;
    // }
  }
}
</style>
